module.exports = __webpack_public_path__ + "static/img/download.221be0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download.jpg
// module id = jCjf
// module chunks = 0